<template>
  <PageManager
    :iframe-target="`${link}/${pageUrl}`"
    :overrides="pages"
    :currentPage="currentPage"
    :page="page"
  >

    <template #before-sidebar>
      <NavigationSidebar
        class="!w-60"
        :pages="pages"

        v-model="page"
      >
        <template v-slot="{ id }">
          <svg v-if="id === 'checkout-cart'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
            <path fill-rule="evenodd" d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 004.25 22.5h15.5a1.875 1.875 0 001.865-2.071l-1.263-12a1.875 1.875 0 00-1.865-1.679H16.5V6a4.5 4.5 0 10-9 0zM12 3a3 3 0 00-3 3v.75h6V6a3 3 0 00-3-3zm-3 8.25a3 3 0 106 0v-.75a.75.75 0 011.5 0v.75a4.5 4.5 0 11-9 0v-.75a.75.75 0 011.5 0v.75z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="id === 'checkout-address'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-5 h-5">
            <path fill-rule="evenodd" d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z" clip-rule="evenodd" />
          </svg>
          <svg v-else-if="id === 'checkout-success'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6">
            <path fill-rule="evenodd" d="M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12zm13.36-1.814a.75.75 0 10-1.22-.872l-3.236 4.53L9.53 12.22a.75.75 0 00-1.06 1.06l2.25 2.25a.75.75 0 001.14-.094l3.75-5.25z" clip-rule="evenodd" />
          </svg>
        </template>
      </NavigationSidebar>
    </template>

  </PageManager>
</template>

<script>

import NavigationSidebar from "@/components/SideEditor/NavigationSidebar"
import PageManager from "@/components/SideEditor/PageManager.vue"

import { mapGetters } from "vuex"
import mixin from "./mixin"

export default {
  mixins: [mixin],
  components: {
    PageManager,
    NavigationSidebar,
  },
  data() {
    return {
      page: null,
      pages: [
        {
          name: "Cart Items",
          id: "checkout-cart",
        },
        {
          name: "Address Information",
          id: "checkout-address",
        },
        {
          name: "Checkout Success",
          to: 'checkout/onepage/success',
          id: "checkout-success",
        },
      ],
    }
  },
  computed: {
    ...mapGetters({
      link: 'editor/fullDomainLink',
    }),

    pageUrl() {
      switch (this.page) {
        case "checkout-cart": return "checkout/cart/"
        case "checkout-address": return "checkout/address"
        case "checkout-success": return "checkout-success-page"
      }
    },
  },
}

</script>
